import * as React from "react";

const SvgVideo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="currentColor"
  >
    <path
      d="M2.66667 13.3333C2.3 13.3333 1.98611 13.2028 1.725 12.9417C1.46389 12.6805 1.33333 12.3667 1.33333 12V3.99999C1.33333 3.63332 1.46389 3.31943 1.725 3.05832C1.98611 2.79721 2.3 2.66666 2.66667 2.66666H10.6667C11.0333 2.66666 11.3472 2.79721 11.6083 3.05832C11.8694 3.31943 12 3.63332 12 3.99999V6.99999L14.6667 4.33332V11.6667L12 8.99999V12C12 12.3667 11.8694 12.6805 11.6083 12.9417C11.3472 13.2028 11.0333 13.3333 10.6667 13.3333H2.66667ZM2.66667 12H10.6667V3.99999H2.66667V12Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgVideo;
